module.exports = ".THEME_NAME.md-subheader.md-primary {\n  color: PRIMARY-COLOR; }\n\n.THEME_NAME.md-subheader.md-accent {\n  color: ACCENT-COLOR; }\n\n.THEME_NAME.md-subheader.md-warn {\n  color: WARN-COLOR; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/mdSubheader/mdSubheader.theme
// module id = 195
// module chunks = 19 26